import PropTypes from "prop-types";
import React from "react";
import ENV from "app/utils/ENV";
import { View, TouchableOpacity, TouchableWithoutFeedback } from "react-native";
import valueHelpers from "app/utils/valueHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueActions from "app/utils/valueActions";
import alertActions from "app/utils/alertActions";
import Text from "app/components/Text";
import store from "app/redux/store";
import * as RootNavigation from "app/utils/RootNavigation.js";
import HoverableTooltip from "app/components/HoverableTooltip";

import { StyleContext } from "app/contexts/Style";

export default class MultiButton extends React.Component {
  static contextType = StyleContext;
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: null,
      showOptions: false,
    };
  }

  render() {
    let { text, action, options, small, tooltipText } = this.props;
    let { selectedIndex, showOptions } = this.state;
    return (
      <HoverableTooltip text={showOptions ? undefined : tooltipText}>
        <View style={this.styles().wrapper}>
          <Text
            button
            smallButton={small}
            onPress={this.handleAction}
            style={!small ? this.styles().buttonText : { marginRight: 0 }}
            numberOfLines={1}
          >
            {options[selectedIndex]?.text || text}
          </Text>
          <TouchableOpacity
            style={[
              this.styles().optionsToggle,
              small && { width: this.context.sizes.large },
            ]}
            onPress={this.toggleSelector}
          >
            <Text small={small}>{showOptions ? "^" : "v"}</Text>
          </TouchableOpacity>
          {showOptions && this.renderOptions()}
        </View>
      </HoverableTooltip>
    );
  }

  renderOptions = () => {
    let { options } = this.props;
    let { selectedIndex } = this.state;
    return (
      <View style={this.styles().optionsWrapper}>
        {options.map((opt, i) => (
          <Text
            key={i}
            numberOfLines={1}
            style={[
              this.styles().option,
              selectedIndex == i && this.styles().selectedOption,
            ]}
            onPress={() => {
              this.setState({
                selectedIndex: selectedIndex == i ? null : i,
                showOptions: false,
              });
            }}
          >
            {opt.text}
          </Text>
        ))}
      </View>
    );
  };

  toggleSelector = async () => {
    if (ENV.WEB) {
      this.setState({ showOptions: !this.state.showOptions });
    } else {
      let { options } = this.props;
      let res = await alertActions.confirm({
        options: options.map((o) => o.text),
      });
      if (res > 0) {
        await this.setState({ selectedIndex: res - 1 });
        // this.handleAction();
      }
    }
  };

  handleAction = () => {
    let { action, options } = this.props;
    let { selectedIndex } = this.state;
    if (selectedIndex != null) {
      options[selectedIndex].action();
    } else if (!!action) {
      action();
    } else {
      if (ENV.WEB) this.toggleSelector();
    }
  };

  styles = () => {
    return {
      wrapper: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        borderRadius: this.context.sizes.borderRadius,
        backgroundColor: this.context.colors.fill,
        marginRight: this.context.sizes.base,
      },
      buttonText: {
        // minWidth: 70,
        margin: this.context.sizes.tiny,
        marginRight: 0,
      },
      optionsToggle: {
        width: this.context.sizes.itemHeight,
        margin: this.context.sizes.tiny,
        marginLeft: 0,
        borderLeftWidth: 1,
        borderColor: this.context.colors.trim,
        justifyContent: "center",
        alignItems: "center",
      },
      optionsWrapper: {
        position: "absolute",
        top: "100%",
        // left: 0,
        right: 0,
        zIndex: 1,
      },
      option: {
        padding: this.context.sizes.small,
        borderBottomWidth: 1,
        borderColor: this.context.colors.trim,
        backgroundColor: this.context.colors.fill,
      },
      selectedOption: {
        backgroundColor: this.context.colors.trim,
      },
    };
  };
}
